(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderForward',
	};

	var recipients = [];

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#fitbuilderforward-to').on('blur', function _addRecipients(e) {
			loseFocus($(this).val());
		});

		$('#fitbuilderforward-to').on('keydown', function _addRecipients(e) {
			if (e.which === 13) {
				e.preventDefault();

				loseFocus($(this).val());
			}
		});

		$('.fit-builder-interior').on('click', '.fit-email-list', function _removeEmail() {
			var email = $(this).data('email'),
				index = recipients.indexOf(email);

			if (index !== -1) {
				recipients.splice(index, 1);
			}

			$('#fitbuilderforward-recipients').val(JSON.stringify(recipients));

			if (recipients.length >= 1) {
				$('.email-list').removeClass('hidden');

				populateEmailVisualList();
			} else {
				$('.email-list').addClass('hidden');
			}
		});
	};

	function loseFocus(email)
	{
		if (email.length > 0) {
			if (Adzuki.String.isEmail(email)) {
				recipients.push(email);
				$('#fitbuilderforward-to').val('');
			} else {
				Adzuki.StatusMessage('error', 'Sorry ' + email + ' is not a valid email address');
			}

			$('#fitbuilderforward-recipients').val(JSON.stringify(recipients));
		}

		if (recipients.length >= 1) {
			$('.email-list').removeClass('hidden');

			populateEmailVisualList();
		} else {
			$('.email-list').addClass('hidden');
		}
	}

	function populateEmailVisualList()
	{
		var html = '',
			i;

		for (i = 0; i<recipients.length; i++) {
			html += '<span class="fit-email-list" data-email="' + recipients[i] + '">' + recipients[i] + ' <i class="far fa-times-circle"></i></span>';
		}

		$('.email-list-contents').html(html);
	}

}(jQuery, window.Adzuki || {}));
